// UserInfoComponents.jsx
import React from 'react';

export const ClientInfo = ({ clientInfo }) => {
	return (
		<>
			<label style={{ textTransform: 'capitalize' }}>{clientInfo?.company_name || '-'}</label>
			<span>{clientInfo?.client}</span>
			<span>Matricule Fiscale: {clientInfo?.tax_registration_number || '-'}</span>{' '}
			<span>N° téléphone: {clientInfo?.phone ?? ''}</span>
		</>
	);
};

export const ShopInfo = ({ shop }) => {
	if (!shop) {
		return null;
	}

	return (
		<div>
			<span>{shop.address_number} </span>
			<span>{shop.street} </span>
			<span>{shop.ville} </span>
			<span>{shop.postal_code} </span>
			<span>{shop.region} </span>
		</div>
	);
};

export const SuperAdminInfo = ({ superAdminInfo }) => {
	const companies = Array.isArray(superAdminInfo) ? superAdminInfo : [superAdminInfo];

	return (
		<div className='footer'>
			{companies.map((company, index) => (
				<div className='left' key={company?._id || index}>
					<ul>
						<li>
							{' '}
							Company Name : <strong>{company?.name || '-'}</strong>
						</li>
						<li>Company Address : {company?.address || '-'}</li>
						<li>
							CODE TVA : <span>{company?.tva_code || '-'}</span>
						</li>
						<li>
							RC : <span>{company?.r_c || '-'}</span>
						</li>
						<li>
							Code en Douane : <span>{company?.customs_code || '-'}</span>
						</li>
						<li>
							Tél : <span>{company?.phone || '-'}</span>
						</li>
						<li>
							Fax : <span>{company?.fax || '-'}</span>
						</li>
						<li>
							Email: <span>{company?.email || '-'}</span>
						</li>
					</ul>
				</div>
			))}
		</div>
	);
};
